import CombinedProblemGenerator, { CombinedProblemConfigs } from "./CombinedProblemGenerator";
import { IProblem, IProblemGenerator } from "./sharedTypes";

/**
 * Allows for being able to select sets of problems to work on.  Each 'preset' can be enabled/disabled to make for more easy changes to difficulty levels.
 */
export class QuestionSetProblemGenerator implements IProblemGenerator {
    private generators : Array<CombinedProblemGenerator>;
    private lastProblem: IProblem | undefined;

    constructor(presets: string[]) {
        this.generators = [];

        //console.log(`Presets: `, presets)
        for (var presetName of presets) {
            let preset = Presets[presetName];
            if (preset !== undefined) {
                const newGenerator = new CombinedProblemGenerator(preset.configs);
                this.generators.push(newGenerator);
            }
        }

        //console.log(`Generators: `, this.generators)
    }
    getNext() {
        if (this.generators.length === 0) {
            return { display: "1 + 1", correctAnswer: 2 } as IProblem;
        }
        while(true) {
            let rnd = Math.floor(Math.random() * this.generators.length);
            let probOut = this.generators[rnd].getNext();

            if (probOut.display !== this.lastProblem?.display)
                return probOut;
        }
    }
}


type GeneratorPreset = {
    category: "Addition" | "Subtraction" | "Multiplication" | "Division";
    description: string,
    configs: CombinedProblemConfigs
}

export const Presets: { [key: string]: GeneratorPreset } = {
    "Single Digit Addition" : {
        category: "Addition",
        description: "Single digit addition up to 9+9",
        configs: { addition: { frequency: 1, maxResult: 18, operand1: { max: 9 }, operand2: { max: 9 } }}
    },
    "Simple Double Digit Addition" : {
        category: "Addition",
        description: "Addition up to a sum of 25",
        configs: { addition: { frequency: 1, maxResult: 25 }},
    },
    "Single Digit Subtraction": {
        category: "Subtraction",
        description: "Subtraction from up to 9",
        configs: { subtraction: { frequency: 1, operand1: { min: 1, max: 9 }, operand2: { min: 1, max: 9} }},
    },
    "Simple Double Digit Subtraction": {
        category: "Subtraction",
        description: "Subtraction from 10-20",
        configs: {subtraction: { frequency: 1, operand1: { min: 10, max: 20 }, operand2: { min: 0, max: 20 }}},
    },
    "2x Multiplication": {
        category: "Multiplication",
        description: "Multiplication by 2 of 0-12",
        configs: { multiplication: { frequency: 1, operand1: { min: 2, max: 2}, operand2: { min: 0, max: 12 } }},
    },
    "3x Multiplication": {
        category: "Multiplication",
        description: "Multiplication by 3 of 0-12",
        configs: { multiplication: { frequency: 1, operand1: { min: 3, max: 3}, operand2: { min: 0, max: 12 } }},
    },
    "4x Multiplication": {
        category: "Multiplication",
        description: "Multiplication by 4 of 0-12",
        configs: { multiplication: { frequency: 1, operand1: { min: 4, max: 4}, operand2: { min: 0, max: 12 } }},
    },
    "5x Multiplication": {
        category: "Multiplication",
        description: "Multiplication by 5 of 0-12",
        configs: { multiplication: { frequency: 1, operand1: { min: 5, max: 5}, operand2: { min: 0, max: 12 } }},
    },
    "6x Multiplication": {
        category: "Multiplication",
        description: "Multiplication by 6 of 0-12",
        configs: { multiplication: { frequency: 1, operand1: { min: 6, max: 6}, operand2: { min: 0, max: 12 } }},
    },
    "7x Multiplication": {
        category: "Multiplication",
        description: "Multiplication by 7 of 0-12",
        configs: { multiplication: { frequency: 1, operand1: { min: 7, max: 7}, operand2: { min: 0, max: 12 } }},
    },
    "8x Multiplication": {
        category: "Multiplication",
        description: "Multiplication by 8 of 0-12",
        configs: { multiplication: { frequency: 1, operand1: { min: 8, max: 8}, operand2: { min: 0, max: 12 } }},
    },
    "9x Multiplication": {
        category: "Multiplication",
        description: "Multiplication by 9 of 0-12",
        configs: { multiplication: { frequency: 1, operand1: { min: 9, max: 9}, operand2: { min: 0, max: 12 } }},
    },
    "10x Multiplication": {
        category: "Multiplication",
        description: "Multiplication by 10 of 0-12",
        configs: { multiplication: { frequency: 1, operand1: { min: 10, max: 10}, operand2: { min: 0, max: 12 } }},
    },
    "11x Multiplication": {
        category: "Multiplication",
        description: "Multiplication by 11 of 0-12",
        configs: { multiplication: { frequency: 1, operand1: { min: 11, max: 11}, operand2: { min: 0, max: 12 } }},
    },
    "12x Multiplication": {
        category: "Multiplication",
        description: "Multiplication by 12 of 0-12",
        configs: { multiplication: { frequency: 1, operand1: { min: 12, max: 12}, operand2: { min: 0, max: 12 } }},
    },

    "Simple Division Part 1": {
        category: "Division",
        description: "Division up to 36/9",
        configs: { division: { frequency: 1, operand1: { min: 1, max: 9}, operand2: { min:1, max:4}}}
    },
    "Simple Division Part 2": {
        category: "Division",
        description: "Division up to 81/9",
        configs: { division: { frequency: 1, operand1: { min: 1, max: 9}, operand2: { min:1, max:9}}}
    },
}
